import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  boolean,
  object,
  FormSubmit,
} from 'libs/form';

export interface NotificationsFormType {
  onboardingStatus: {
    isBellEnabled: boolean;
    isEmailEnabled: boolean;
  };
}

export const getSchema = (): ObjectSchema<NotificationsFormType> =>
  object({
    onboardingStatus: object({
      isBellEnabled: boolean().required(),
      isEmailEnabled: boolean().required(),
    }).required(),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<NotificationsFormType>();

export type FormErrors = FormErrorsBase<NotificationsFormType>;

export type NotificationsFormSubmit = FormSubmit<NotificationsFormType>;
